import OwnerAssignment from "./OwnerAssignment";
import useIsSmall from "@/hooks/useIsSmall";
import DesktopCustomers from "./desktop";
import MobileCustomers from "./mobile";

function Customers() {
  const matches = useIsSmall();

  return <><OwnerAssignment />{matches ? <MobileCustomers /> : <DesktopCustomers />}</>;
}

export default Customers;
